module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (218).e43467ea.jpg";